import Service, { inject as service } from '@ember/service';
import { dropTask } from 'ember-concurrency';
import ApiErrorsService from 'cio/services/api-errors';
import ApiService from './api';
import { Credential, GistAuthenticationToken } from 'cio/utils/in-app/credentials';

export default class InAppCredentialsService extends Service {
  @service api!: ApiService;
  @service apiErrors!: ApiErrorsService;

  loadCredential = dropTask(async () => {
    let response = <{ credential: Credential | null }>{};
    let isIntegrationEnabled = false;
    try {
      response = await this.api.request('credentials/in_app', {
        ignoreErrors: true,
        includeStatus: true,
      });
      isIntegrationEnabled = true;
    } catch (e) {
      if (e.status === '404') {
        isIntegrationEnabled = false;
      } else {
        this.apiErrors.report(e);
      }
    }

    return { credential: response.credential, isIntegrationEnabled };
  });

  loadGistAuthenticationToken = dropTask(async () => {
    let response: GistAuthenticationToken = {};
    try {
      response = await this.api.request('in_app/token', {
        ignoreErrors: true,
        includeStatus: true,
      });
    } catch (e) {
      if (e.status !== '404') {
        this.apiErrors.report(e);
      }
    }
    return response;
  });
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    'in-app-credentials': InAppCredentialsService;
  }
}
